import { useMutation, useQuery } from "@apollo/client";
import { JOB_CLASSIFICATIONS_QUERY, UPDATE_CHANGE_REQUEST_MUTATION, Node } from "../queries";
import Button from "@/components/Button";
import Progress from "@/components/Progress";
import useAmplitude from "@/hooks/useAmplitude";
import useModal from "@/hooks/useModal";
import { SECTION_ANALYTICS_EVENTS, getSectionAnalyticsData } from "@/pages/sections/_utils/amplitude";
import { useState } from "react";
import Select from "@/components/Select";

export default function EditModal({ changeRequest, onClosed }: { changeRequest: Node; onClosed(): void }) {
  const { Modal, save } = useModal();
  const { trackEvent } = useAmplitude();
  const { data, loading } = useQuery(JOB_CLASSIFICATIONS_QUERY, { variables: { personId: changeRequest.person.id } });
  const [selectedClassification, selectClassification] = useState(
    "classification" in changeRequest.change ? changeRequest.change.classification || "" : ""
  );

  const [update, { loading: updating }] = useMutation(UPDATE_CHANGE_REQUEST_MUTATION);

  const { availableJobClassifications = [] } = data?.person || {};

  const options = availableJobClassifications.map((value) => ({ value }));

  const onSave = () =>
    save(
      async () => {
        const result = await update({
          variables: { id: changeRequest.id, classification: selectedClassification }
        });
        if (result.data?.updateChangeRequest?.success) {
          trackEvent(
            SECTION_ANALYTICS_EVENTS.changeRequestUpdated,
            getSectionAnalyticsData({
              source: "section_change_requests",
              sectionId: changeRequest.section.id,
              changeRequestId: changeRequest.id,
              changeType: changeRequest.change.__typename,
              action: "edit",
              field: "classification"
            })
          );
        }
        return result;
      },
      (data) => data.updateChangeRequest,
      "Requested value updated"
    );

  return (
    <Modal
      displayOverflow
      action={
        <Button disabled={!selectedClassification || updating} onClick={onSave} icon="check">
          Save
        </Button>
      }
      headline="Edit Requested Value"
      onClosed={onClosed}
    >
      <>
        {loading ? (
          <Progress variant="linear" />
        ) : (
          <Select
            label="Classification"
            className="w-full"
            onSelect={selectClassification}
            options={options}
            value={selectedClassification}
          />
        )}
      </>
    </Modal>
  );
}
